export default __webpack_public_path__ + "static/media/11.e3f921b8.svg";